module.exports = __webpack_public_path__ + "img/joinmember_text.b64cfd8b.png";